import { render } from "./AlmButtonRenderer.vue?vue&type=template&id=6e530aae&ts=true"
import script from "./AlmButtonRenderer.vue?vue&type=script&lang=ts"
export * from "./AlmButtonRenderer.vue?vue&type=script&lang=ts"

import "./AlmButtonRenderer.vue?vue&type=style&index=0&id=6e530aae&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__